import { render, staticRenderFns } from "./elMenuTree.vue?vue&type=template&id=564d14c0"
import script from "./elMenuTree.vue?vue&type=script&lang=js"
export * from "./elMenuTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports